const clamp01 = (n) => Math.min(1, Math.max(0, n))
const lerp = (a, b, t) => a + (b - a) * t
const DAMPING = 0.12
const NAV_RANGE = 140

function navProgressTarget() {
    return clamp01(window.scrollY / NAV_RANGE)
}

;(function () {
    const reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
    ).matches

    const lenis = new Lenis(
        reducedMotion
            ? { lerp: 1, smoothWheel: false, syncTouch: false }
            : {
                  lerp: 0.10,
                  smoothWheel: true,
                  syncTouch: false,
                  allowNestedScroll: true,
              }
    )

    window.lenis = lenis

    const readers = new Set()
    const writers = new Set()

    window.themeTicker = {
        read(fn) {
            readers.add(fn)
            return () => readers.delete(fn)
        },
        write(fn) {
            writers.add(fn)
            return () => writers.delete(fn)
        },
    }

    const navDamping = reducedMotion ? 1 : DAMPING
    let navCur = navProgressTarget()
    let nav = document.querySelector("header-487")

    function setNav(p) {
        if (!nav || !nav.isConnected) nav = document.querySelector("header-487")
        if (nav) nav.style.setProperty("--nav-p", p.toFixed(4))
    }

    function runPhase(phase, time) {
        for (const fn of phase) {
            try {
                fn(time)
            } catch (error) {
                phase.delete(fn)
                console.error(
                    "themeTicker: callback removed after error",
                    error
                )
            }
        }
    }

    function frame(time) {
        requestAnimationFrame(frame)

        lenis.raf(time)

        runPhase(readers, time)
        runPhase(writers, time)

        const navT = window.menuOpen ? 1 : navProgressTarget()
        navCur = lerp(navCur, navT, navDamping)
        if (Math.abs(navT - navCur) < 0.0004) navCur = navT
        setNav(navCur)
    }

    setNav(navCur)
    requestAnimationFrame(frame)
})()
